import React from 'react';
import { whatsappHref } from '../data/siteContent';

const WhatsAppButton = () => (
  <a
    href={whatsappHref}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 right-6 z-[100] flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg hover:scale-105 transition-transform"
    aria-label="WhatsApp"
  >
    <i className="fab fa-whatsapp text-2xl" aria-hidden="true" />
  </a>
);

export default WhatsAppButton;
